import * as React from 'react';
import './style.scss';
import { Colors } from './colors';

interface ButtonProps {
    text: string;
    click: () => void;
    backgroundColor?: string;
}

function Button(props: ButtonProps) {
    const {
        text,
        backgroundColor,
        click,
    } = props;

    const getButtonMods = (): string => {
        const classList: string[] = ['button'];
        if (backgroundColor === Colors.blue) classList.push('button_blue');
        if (backgroundColor === Colors.lightGrey) classList.push('button_grey');
        return classList.join(' ');
    };

    return (
        <div onClick={click} className={getButtonMods()}>
            {text}
        </div>
    );
}

export default Button;
